<template>
    <div>
        <v-dialog
            v-model="isOpen"
            max-width="600"
            @keydown.esc.prevent="closeInsertPopup"
            persistent
            @click:outside="closeInsertPopup"
            content-class="modalCopy"
        >
            <v-container>
                <v-layout row class="d-flex flex-column">
                    <h3 class="text-center text-uppercase pb-5 pt-5" style="background: #f5f5f5; margin-top: -12px;">Add Recipients</h3>
                    <v-flex>
                        <v-flex v-if="level === 'Personal'" style="background: #f5f5f5; padding: 0 30px;">
                            <v-btn color="black lighten-2" text class="btn-filter pa-1 mb-5" @click="showPersonalFilters = !showPersonalFilters">
                                Filters
                                <v-icon style="fill: #000;" right>$filter</v-icon>
                            </v-btn>
                            <v-flex v-if="showPersonalFilters" class="d-flex justify-space-between">
                                <div class="mb-2">
                                    <h3 class="ma-0 mb-3">Roles</h3>
                                    <v-autocomplete
                                        :items="$store.getters.getVisibleRoles"
                                        item-text="title"
                                        item-value="id"
                                        placeholder="Role"
                                        v-model="selectedRoles"
                                        dense
                                        solo
                                        lighten-1
                                        multiple
                                        return-object
                                        :search-input.sync="searchInputAutocomplete[searchInputConst.roles]"
                                        @change="cleanEmployees(true, searchInputConst.roles)"
                                        style="width: 250px;"
                                        height="30px"
                                    ><template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ selectedRoles.length - 1 }} others)</span>
                                    </template></v-autocomplete>
                                </div>
                                <div class="mb-2">
                                    <h3 class="ma-0 mb-3">Clinics</h3>
                                    <v-autocomplete
                                        :items="clinics"
                                        item-text="title"
                                        item-value="id"
                                        placeholder="Clinic"
                                        v-model="selectedClinics"
                                        dense
                                        solo
                                        lighten-1
                                        :multiple="!isAdhoc"
                                        return-object
                                        :search-input.sync="searchInputAutocomplete[searchInputConst.clinics]"
                                        @change="onSelectEmployee(true, searchInputConst.clinics)"
                                        style="width: 250px;"
                                        height="30px"
                                    ><template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ selectedClinics.length - 1 }} others)</span>
                                    </template></v-autocomplete>
                                </div>
                            </v-flex>
                        </v-flex>
                        <v-flex v-else class="filtersBlock d-flex justify-space-between">
                            <div class="mb-2">
                                <h3 class="ma-0 mb-3">Roles</h3>
                                <v-autocomplete
                                    :items="$store.getters.getVisibleRoles"
                                    item-text="title"
                                    item-value="id"
                                    placeholder="Role"
                                    v-model="selectedRoles"
                                    dense
                                    solo
                                    lighten-1
                                    multiple
                                    return-object
                                    :search-input.sync="searchInputAutocomplete[searchInputConst.roles]"
                                    @change="cleanEmployees(true, searchInputConst.roles)"
                                    style="width: 250px;"
                                    height="30px"
                                ><template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ selectedRoles.length - 1 }} others)</span>
                                </template></v-autocomplete>
                            </div>
                            <div class="mb-2" v-if="level !== 'Surgery'">
                                <h3 class="ma-0 mb-3">Clinics</h3>
                                <v-autocomplete
                                    :items="clinics"
                                    item-text="title"
                                    item-value="id"
                                    placeholder="Clinic"
                                    v-model="selectedClinics"
                                    dense
                                    solo
                                    lighten-1
                                    :multiple="!isAdhoc"
                                    return-object
                                    :search-input.sync="searchInputAutocomplete[searchInputConst.clinics]"
                                    @change="onSelectEmployee(true, searchInputConst.clinics)"
                                    style="width: 250px;"
                                    height="30px"
                                ><template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ selectedClinics.length - 1 }} others)</span>
                                </template></v-autocomplete>
                            </div>
                            <div class="mb-2" v-if="level === 'Surgery'">
                                <h3 class="ma-0 mb-3">Sub units</h3>
                                <v-autocomplete
                                    :items="clinicsSurgeries"
                                    item-text="fullName"
                                    item-value="id"
                                    placeholder="Sub-unit"
                                    v-model="selectedSurgery"
                                    dense
                                    solo
                                    lighten-1
                                    multiple
                                    :search-input.sync="searchInputAutocomplete[searchInputConst.subUnits]"
                                    @change="changeOption(true, searchInputConst.subUnits)"
                                    return-object
                                    style="width: 250px;"
                                    height="30px"
                                ><template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="selection-text-style">{{ item.fullName }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ selectedSurgery.length - 1 }} others)</span>
                                </template></v-autocomplete>
                            </div>
                        </v-flex>
                        <v-flex class="filtersBlock" v-if="level === 'Personal'">
                            <div class="mb-2">
                                <h3 class="ma-0 mb-3 text-center">Employees</h3>
                                <v-autocomplete
                                    :items="employeesByRoleAndClinic"
                                    item-text="fullName"
                                    item-value="id"
                                    placeholder="Employee"
                                    v-model="selectedEmployee"
                                    dense
                                    solo
                                    lighten-1
                                    multiple
                                    return-object
                                    height="30px"
                                >
                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ item.fullName }}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ selectedEmployee.length - 1 }} others)</span>
                                    </template>
                                    <template
                                        slot="prepend-item"
                                    >
                                        <v-checkbox v-model="allEmployees" class="ml-4 font-weight-bold" label="Select All"></v-checkbox>
                                    </template>
                                </v-autocomplete>
                            </div>
                        </v-flex>
                    </v-flex>
                    <v-flex class="d-flex justify-center mt-5">
                        <v-btn class="mx-4" @click="closeInsertPopup">Cancel</v-btn>
                        <v-btn v-if="level === 'Personal'" color="primary" :disabled="!selectedEmployee.length" @click="insertButtonClick">Insert</v-btn>
                        <v-btn v-if="level === 'Surgery'" color="primary" :disabled="!selectedRoles.length || !selectedSurgery.length" @click="insertButtonClick">Insert</v-btn>
                        <v-btn v-if="level === 'ClinicOrHQ'" color="primary" :disabled="!selectedRoles.length || !selectedClinics.length" @click="insertButtonClick">Insert</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
  import selectInputAutocomplete from '../../../constatns/selectInputAutocomplete'

  export default {
    props: ['isOpen', 'level', 'isAdhoc'],
    data: () => ({
      selectedRoles: [],
      selectedClinics: [],
      selectedEmployee: [],
      selectedSurgery: [],
      allEmployees: false,
      showPersonalFilters: false,
      searchInputConst: selectInputAutocomplete,
      searchInputAutocomplete: {
        [selectInputAutocomplete.roles]: null,
        [selectInputAutocomplete.clinics]: null,
        [selectInputAutocomplete.subUnits]: null
      }
    }),
    computed: {
      employeesByRoleAndClinic () {
        const employees = []
        if (this.selectedRoles.length || this.selectedClinics.length) {
          this.$store.getters.getEmployeesSorted.forEach(empl => {
            empl.clinicRoles.forEach(clinicRole => {
              if (this.selectedRoles.length && this.selectedClinics.length) {
                this.selectedRoles.forEach(role => {
                  this.selectedClinics.forEach(clinic => {
                    if (clinicRole.id === role.title && clinicRole.value === clinic.title) {
                      if (!employees.find(item => item === empl)) {
                        employees.push(empl)
                      }
                    }
                  })
                })
              } else if (this.selectedRoles.length && !this.selectedClinics.length) {
                this.selectedRoles.forEach(role => {
                    if (clinicRole.id === role.title) {
                      if (!employees.find(item => item === empl)) {
                        employees.push(empl)
                      }
                    }
                })
              } else if (!this.selectedRoles.length && this.selectedClinics.length) {
                  this.selectedClinics.forEach(clinic => {
                    if (clinicRole.value === clinic.title) {
                      if (!employees.find(item => item === empl)) {
                        employees.push(empl)
                      }
                    }
                  })
              }
            })
          }, [])
        } else {
          this.$store.getters.getEmployeesSorted.forEach(item => {
            employees.push(item)
          })
        }
        return employees
      },
      clinicsSurgeries () {
        let clinics
        if (this.isAdhoc) {
          clinics = [this.$store.getters.getClinicById(this.$store.getters.getUserActiveClinic)] // If no clinic, it set id = 1
        } else {
          clinics = this.$store.getters.getClinicsByCurrentGroupWithHq
        }
        return this.$store.getters.getSurgeriesWithClinicNames(clinics)
      },
      clinics () {
        if (this.isAdhoc) {
          const clinic = this.$store.getters.getClinicById(this.$store.getters.getUserActiveClinic)
          this.setClinic(clinic)
          return clinic // If no clinic, it set id = 1
        } else {
          return this.$store.getters.getClinicsByCurrentGroupWithHq
        }
      }
    },
    methods: {
      setClinic (item) {
        this.selectedClinics = item
      },
      cleanEmployees (isResetInput, typeSearch) {
        if (isResetInput) {
          this.changeOption(typeSearch)
        }
        this.selectedEmployee = []
        this.allEmployees = false
      },
      closeInsertPopup () {
        this.cleanEmployees()
        this.selectedRoles = []
        if (this.isAdhoc) {
          this.selectedClinics = this.$store.getters.getClinicById(this.$store.getters.getUserActiveClinic)
        } else {
          this.selectedClinics = []
        }
        this.selectedSurgery = []
        this.$emit('closeFilterPopup')
      },
      insertButtonClick () {
        this.$emit('insertRowsData', {
          employees: this.selectedEmployee,
          clinics: this.selectedClinics.map(clinic => {
            return this.selectedRoles.map(role => {
              return {
                id: clinic.id,
                roleId: role.id
              }
            })
          }),
          surgeries: this.selectedSurgery.map(surgery => {
            return this.selectedRoles.map(role => {
              return {
                id: surgery.id,
                roleId: role.id,
                fullName: surgery.fullName,
                clinicId: surgery.clinicId
              }
            })
          })
        })
        this.closeInsertPopup()
      },
      onSelectEmployee (isResetInput, typeSearch) {
        if (isResetInput) {
          this.changeOption(typeSearch)
        }
        this.selectedEmployee = []
      },
      changeOption (typeSearch) {
        this.searchInputAutocomplete[typeSearch] = ''
      }
    },
    watch: {
      allEmployees: function () {
        if (this.allEmployees) {
          this.selectedEmployee = this.employeesByRoleAndClinic
        } else {
          this.selectedEmployee = []
        }
      }
    }
  }
</script>

<style lang="scss">
    .modalCopy {
        background: #fff;
    }
    .filtersBlock {
        margin-top: 20px;
        padding: 0 30px;
    }
</style>
